import { type NextPage } from 'next'

import {
  ChatWhatsAppSupportButton,
  setWhatsAppSupportButtonVisible
} from '~/domains/platform/infra/chat/components/whatsapp'

import { type WithDeusExMachinaProps } from '../../deus-ex-machina/ports'

import { useWhatsAppSupportButtonVisibility } from './use-whatsapp-support-button-visibility'

export function withWhatsAppSupportButton(hasHeaderNavigation: boolean) {
  return function (Page: NextPage<WithDeusExMachinaProps>) {
    function WrappedPage(props: WithDeusExMachinaProps) {
      const isOneStone = props?.entity?.stoneAccount?.situation === 'one_stone'
      const isVisible = useWhatsAppSupportButtonVisibility(props?.subject?.id ?? '', isOneStone)

      if (hasHeaderNavigation) {
        setWhatsAppSupportButtonVisible(isVisible)
        return <Page {...props} />
      }

      return (
        <>
          <Page {...props} />
          {isVisible && (
            <div className="fixed bottom-6 right-6 z-50">
              <ChatWhatsAppSupportButton />
            </div>
          )}
        </>
      )
    }

    WrappedPage.displayName = `withWhatsAppSupportButton(${Page.displayName})`

    return WrappedPage
  }
}
